<template lang="pug">
    v-card(
        elevation="4"
        shaped
        style="min-height: 600px !important;"
    )
        v-toolbar(dense)
            v-icon.mr-2 mdi-phone
            v-toolbar-title Calls Stats
            
        v-card-text(v-if="validDayDashboardSummary")
            v-container(style="width: 100%; padding: 10px;")
                v-row.align-center
                    v-col(cols="6" style="padding-right: 40px")
                        v-row.align-center(style="padding: 10px;")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Inbound Calls
                                .text-h4.font-weight-bold {{ currentDayDashboardSummary.phone_inbound_call_count | number }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-phone-incoming
                        v-row.align-center(style="padding: 10px;")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Missed Calls
                                .text-h4.font-weight-bold {{ currentDayDashboardSummary.remaining_missed_call_count | number }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-phone-missed
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg OB Contact %
                                .text-h4.font-weight-bold {{ (outboundContactPercentage || 0).toFixed(2) | number }}%
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-phone-check
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Agent Drop %
                                .text-h4.font-weight-bold {{ (agentDropPercentage || 0).toFixed(2) | number }}%
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-account-cancel
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg OB Talk Time
                                .text-h4.font-weight-bold {{ (averageOutboundTalkTime || 0) | secondsToFullWords }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-headset
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg IB Talk Time
                                .text-h4.font-weight-bold {{ (averageInboundTalkTime || 0) | secondsToFullWords }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-headset
                    v-col(cols="6" style="padding-left: 40px")
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Outbound Calls
                                .text-h4.font-weight-bold {{ currentDayDashboardSummary.phone_outbound_call_count | number }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-phone-outgoing
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Callbacks
                                .text-h4.font-weight-bold {{ currentDayDashboardSummary.remaining_scheduled_communication_count | number }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-phone-incoming-outgoing
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue New Apts.
                                .text-h4.font-weight-bold {{ currentDayDashboardSummary.appointment_new_count | number }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-calendar-month
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg Hold Time
                                .text-h4.font-weight-bold {{ (averageHoldTime || 0) | secondsToFullWords }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-account-clock
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg OB Wrap Up
                                .text-h4.font-weight-bold {{ (averageOutboundWrapUp || 0) | secondsToFullWords }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-clipboard-check
                        v-row.align-center(style="padding: 10px")
                            .ml-2.text-left 
                                .text-subtitle-1.font-weight-bold.volie-colie-blue Avg IB Wrap Up
                                .text-h4.font-weight-bold {{ (averageInboundWrapUp || 0) | secondsToFullWords }}
                            .ml-auto
                                v-icon.volie-color-blue(size="45")
                                    | mdi-clipboard-check

</template>

<script lang="ts">
    import Vue from 'vue';

    // Helpers
    import { adjustedAgentDropRate, agentDropRate } from '@/helpers/dashboard_summary';

    // Data

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: { 
            calculatePercentage(x, y) {
                if (!x || !y) {
                    return 0;
                }
                return (x / y) * 100.0;
            },
        },
        computed: {
            adjustedAgentDropPercentage() {
                return adjustedAgentDropRate(this.currentDayDashboardSummary);
            },
            agentDropPercentage() {
                return agentDropRate(this.currentDayDashboardSummary);
            },
            averageHoldTime() {
                return this.currentDayDashboardSummary?.total_inbound_hold_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_hold_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            averageInboundTalkTime() {
                return this.currentDayDashboardSummary?.total_inbound_talk_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_answered_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_talk_duration / this.currentDayDashboardSummary.phone_inbound_call_answered_count) : 0;
            },
            averageInboundWrapUp() {
                return this.currentDayDashboardSummary?.total_inbound_wrap_up_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_answered_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_inbound_wrap_up_duration / this.currentDayDashboardSummary.phone_inbound_call_answered_count) : 0;
            },
            averageOutboundTalkTime() {
                return this.currentDayDashboardSummary?.total_outbound_talk_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_outbound_talk_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            averageOutboundWrapUp() {
                return this.currentDayDashboardSummary?.total_outbound_wrap_up_duration > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? Math.floor(this.currentDayDashboardSummary.total_outbound_wrap_up_duration / this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            outboundContactPercentage() {
                return this.currentDayDashboardSummary?.phone_outbound_contact_count > 0 && this.currentDayDashboardSummary?.phone_outbound_call_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_outbound_contact_count, this.currentDayDashboardSummary.phone_outbound_call_count) : 0;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
        },
        components: {
        },
        props: {
            currentDayDashboardSummary: Object,
        },
        watch: {
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
</style>